<template>
  <div class="chart">
    <apexchart ref="chart" type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    name: 'B3TerlayaniBar',
    components: {
        apexchart: VueApexCharts,
    },
    data: function () {
        return {
            series: [],
            chartOptions: {
                title:{
                  text: "Sampah B3/LB3 Kelurahan Terlayani tahun " + this.models.year
                },
                chart: {
                    type: 'bar',
                    height: 380,
                    events: {
                        mounted: (chart) => {
                            chart.windowResizeHandler();
                        }
                    }
                },
                xaxis: {
                    categories: ['Terlayani', 'Tidak Terlayani']
                },
                plotOptions: {
                    bar: {
                        distributed: true,
                    },
                },
                legend: {
                    show: false
                }
            }
        }
    },
    props: {
        models: {
            type: Object,
            required: true,
        },
    },
    mounted() {
      this.getData();
    },
    methods: {
        getData() {
            const _ = this;
            _.$axios.get('DashboardRumahTangga/JumlahSampahRumahTanggaTerlayani', {
                    params: {
                        startDate: `${_.models.year}-01-01`,
                        endDate: `${_.models.year}-12-31`,
                    }
                })
                .then(res => {
                    let data = res.data.data;
                    if(data.length){
                      _.series = [{
                        name: "Terlayani",
                        data: [data[0].terlayani,0]
                      },{
                        name: "Tidak Terlayani",
                        data:  [0,data[0].belumTerlayani]
                      }];
                    }
                    _.$nextTick(() => {
                      _.$refs.chart.init();
                    });
                })
        },
    },
    watch: {
      models: {
        handler(newVal, oldVal) {
          this.getData();
          this.chartOptions.title.text = "Sampah B3/LB3 Kelurahan Terlayani tahun " + this.models.year;
        },
        deep: true,
      },
    },
}
</script>